import React from "react";
import s from "./s.module.scss";
import { useHistory } from "react-router-dom";
import Header from "@share/component/header";
import btcIcon from "@share/img/btc-64x64.png";
import ckbIcon from "@share/img/ckb-64x64.png";
import dashIcon from "@share/img/dash-64x64.png";
import bchIcon from "@share/img/bch-64x64.png";
import ethIcon from "@share/img/eth-64x64.png";
import ltcIcon from "@share/img/ltc-64x64.png";
import zecIcon from "@share/img/zec-64x64.png";
import a10Icon from "@share/img/A10.png";
import a10ProIcon from "@share/img/A10pro.png";
import s19ProIcon from "@share/img/S19pro.png";
import s19Icon from "@share/img/S19.png";
import t19Icon from "@share/img/T19.png";
import m30SIcon from "@share/img/M30S.png";
import m30SPlusIcon from "@share/img/M30Splus.png";
import z15Icon from "@share/img/Z15.png";
const btcItem = [
  {
    id: 1,
    name: "Antminer S19 Pro",
    price: "$8299.00",
    img: s19ProIcon,
  },
  {
    id: 2,
    name: "Antminer S19",
    price: "7299.00$",
    img: s19Icon,
  },
  {
    id: 3,
    name: "Antminer T19",
    price: "5299.00$",
    img: t19Icon,
  },
  {
    id: 4,
    name: "Whatsminer M30S++",
    price: "9899.00$",
    img: m30SPlusIcon,
  },
  {
    id: 12,
    name: "Whatsminer M30S",
    price: "5999.00$",
    img: m30SIcon,
  },
];
const ethItem = [
  {
    id: 5,
    name: "INNOSOLICON A10",
    price: "$6500",
    img: a10Icon,
  },
  {
    id: 6,
    name: " INNOSOLICON A10 Pro",
    price: "$1099",
    img: a10ProIcon,
  },
];
const zecItem = [
  {
    id: 7,
    name: "Antminer Z15",
    price: "3599.00$",
    img: z15Icon,
  },
];
function Shop() {
  const history = useHistory();
  return (
    <div className={s.wrap}>
      <Header />
      <div className={s.content}>
        <div className={s.nav}>
          <span
            className={s.navIcon}
            onClick={() => {
              const target = document.querySelector("#btc");
              if (target) {
                target.scrollIntoView({
                  behavior: "smooth",
                });
              }
            }}
          >
            <img src={btcIcon} />
            BTC
          </span>
          <span
            onClick={() => {
              const target = document.querySelector("#eth");
              if (target) {
                target.scrollIntoView({
                  behavior: "smooth",
                });
              }
            }}
            className={s.navIcon}
          >
            <img src={ethIcon} />
            ETH
          </span>
          <span
            onClick={() => {
              const target = document.querySelector("#zec");
              if (target) {
                target.scrollIntoView({
                  behavior: "smooth",
                });
              }
            }}
            className={s.navIcon}
          >
            <img src={zecIcon} />
            ZEC
          </span>
          <span className={s.navIcon}>
            <img src={dashIcon} />
            DASH
          </span>
          <span className={s.navIcon}>
            <img src={ltcIcon} />
            LTC
          </span>
          <span className={s.navIcon}>
            <img src={bchIcon} />
            BCH
          </span>
          <span className={s.navIcon}>
            <img src={ckbIcon} />
            CKB
          </span>
        </div>
        <h3 className={s.coinTitle} id="btc">
          BTC
        </h3>
        <div className={s.itemWrap}>
          {btcItem.map((item) => {
            return (
              <div
                key={item.id}
                className={s.item}
                onClick={() => {
                  history.push("/miner/" + item.id);
                }}
              >
                <img src={item.img} />
                <p className={s.itemInfo}>
                  <span className={s.itemName}>{item.name}</span>
                  <span className={s.itemPrice}>{item.price}</span>
                </p>
              </div>
            );
          })}
        </div>
        <h3 className={s.coinTitle} id="eth">
          ETH
        </h3>
        <div className={s.itemWrap}>
          {ethItem.map((item) => {
            return (
              <div
                key={item.id}
                className={s.item}
                onClick={() => {
                  history.push("/miner/" + item.id);
                }}
              >
                <img src={item.img} />
                <p className={s.itemInfo}>
                  <span className={s.itemName}>{item.name}</span>
                  <span className={s.itemPrice}>{item.price}</span>
                </p>
              </div>
            );
          })}
        </div>
        <h3 className={s.coinTitle} id="zec">
          ZEC
        </h3>
        <div className={s.itemWrap}>
          {zecItem.map((item) => {
            return (
              <div
                key={item.id}
                className={s.item}
                onClick={() => {
                  history.push("/miner/" + item.id);
                }}
              >
                <img src={item.img} />
                <p className={s.itemInfo}>
                  <span className={s.itemName}>{item.name}</span>
                  <span className={s.itemPrice}>{item.price}</span>
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
export default Shop;
